import React from "react";
import { useSelector } from "react-redux";
import { selectTelemetry, selectTelemetryAccessories } from "../../../redux/selectors";

const PrintTelemetry = () => {
  const telemetryDetails = useSelector(selectTelemetry);
  const telemetryAccessoriesDetails = useSelector(selectTelemetryAccessories);

  const hasTelemetry = telemetryDetails?.some(detail => detail.HasTelemetry);

  if (!hasTelemetry) {
    return null;
  }

  const isZoneEmpty = (detail) => {
    return (
      !detail.Type &&
      !detail.Provider &&
      !detail.SoftwareVersion &&
      !detail.RTUAccessory &&
      !detail.Latitude &&
      !detail.Longitude &&
      !detail.StationToStation &&
      !detail.Comments
    );
  };

  const renderDetails = (details) => {
    if (!details || !Array.isArray(details) || details.length === 0) {
      return null;
    }

    const groupedDetails = details.reduce((acc, detail) => {
      if (!acc[detail.Zone]) {
        acc[detail.Zone] = [];
      }
      acc[detail.Zone].push(detail);
      return acc;
    }, {});

    return (
      <div>
        {Object.keys(groupedDetails).map((zone, index) => {
          const zoneDetails = groupedDetails[zone];
          const accessories = telemetryAccessoriesDetails.filter(accessory => String(accessory.Zone) === zone);

          if (zoneDetails.every(isZoneEmpty) && accessories.length === 0) {
            return null;
          }

          return (
            <div className="section" key={index}>
              <h3 className="print-zone-label">Zone: {zone}</h3>
              <table className="table table-bordered full-width">
                <tbody>
                  {zoneDetails.map((detail, idx) => {
                    if (isZoneEmpty(detail)) {
                      return null;
                    }
                    return (
                      <tr key={idx}>
                        <td className="col-md-6">
                          <table>
                            <tbody>
                              <tr><td><strong>Type: </strong>{detail.Type}</td></tr>
                              <tr><td><strong>Software Version: </strong>{detail.SoftwareVersion}</td></tr>
                              <tr><td><strong>Station To Station: </strong>{detail.StationToStation}</td></tr>
                              <tr><td><strong>Latitude: </strong>{detail.Latitude}</td></tr>
                            </tbody>
                          </table>
                        </td>
                        <td className="col-md-6">
                          <table>
                            <tbody>
                              <tr><td><strong>Provider: </strong>{detail.Provider}</td></tr>
                              <tr><td><strong>RTU Accessory: </strong>{detail.RTUAccessory}</td></tr>
                            <br />
                              <tr><td><strong>Longitude: </strong>{detail.Longitude}</td></tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              {accessories.length > 0 && (
                <>
                  <h4 className="text-center">Telemetry Accessories</h4>
                  <table className="table table-bordered full-width">
                    <thead>
                      <tr>
                        <th>Type</th>
                        <th>Quantity</th>
                      </tr>
                    </thead>
                    <tbody>
                      {accessories.map((accessory, idx) => (
                        <tr key={idx}>
                          <td>{accessory.Type}</td>
                          <td>{accessory.Quantity}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </>
              )}
              <p><strong>Comments:</strong><br />{zoneDetails[0]?.Comments}</p>
              <br className="clearfix" />
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div>
      <h2 className="print-section-header">Telemetry Summary</h2>
      {renderDetails(telemetryDetails)}
    </div>
  );
};

export default PrintTelemetry;
